/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostLinkPatientAuthenticationResponseTypename = "PostLinkPatientAuthenticationResponse" as const;

/**
 *
 * @export
 * @interface PostLinkPatientAuthenticationResponse
 */
export interface PostLinkPatientAuthenticationResponse {
  /**
   *
   * @type {string}
   * @memberof PostLinkPatientAuthenticationResponse
   */
  customToken?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostLinkPatientAuthenticationResponse
   */
  readonly __typename?: string;
}

export function PostLinkPatientAuthenticationResponseFromJSON(json: any): PostLinkPatientAuthenticationResponse {
  return PostLinkPatientAuthenticationResponseFromJSONTyped(json, false);
}

export function PostLinkPatientAuthenticationResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostLinkPatientAuthenticationResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostLinkPatientAuthenticationResponseTypename,

    customToken: !exists(json, "custom_token") ? undefined : json["custom_token"],
  };
}

export function PostLinkPatientAuthenticationResponseToJSON(
  object?: PostLinkPatientAuthenticationResponse | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    custom_token: value.customToken,
  };
}
